export const createStrategicTickPositions = (totalCategories: number): number[] | undefined => {
	if (totalCategories <= 4) {
		return undefined; // Show all labels if 4 or fewer
	}

	if (totalCategories <= 10) {
		// For 5-10 data points, show first, middle, and last labels
		const middle = Math.floor(totalCategories / 2);
		return [0, middle, totalCategories - 1];
	}

	// For more than 10 data points, use strategic positioning
	const step = Math.floor((totalCategories - 1) / 3);
	return [1, step, step * 2, totalCategories - 2];
};
